import { AppState } from "../models";

const STORAGE_KEY = "bab-chart-state";

/**
 * Saves the current application state to LocalStorage.
 */
export function saveToLocal(state: AppState) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
  } catch (e) {
    console.error("Failed to save state to LocalStorage", e);
  }
}

/**
 * Loads the application state from LocalStorage.
 */
export function loadFromLocal(): AppState | null {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    return saved ? JSON.parse(saved) : null;
  } catch (e) {
    console.error("Failed to load state from LocalStorage", e);
    return null;
  }
}
